<template>
    <DModal
        :title="__('customers.contracts.change_runtime')"
        is-confirm
        is-big
        overflow-auto
        :show="showModal"
        @confirm="$emit('save-runtime', runtimeData)"
        @close="$emit('close-modal')"
    >
        <div class="modal-content-padding">
            <DRow>
                <DCol>
                    <PhaseStartDate
                        v-model="runtimeData.start_date"
                        :errors="errors"
                        :disabled="disableStartDateChange"
                        :id-suffix="idSuffix"
                    />

                    <ContractTerm
                        v-model:contractTerm="runtimeData.contract_term"
                        v-model:contractTermUnit="runtimeData.contract_term_unit"
                        :errors="errors"
                        :contract-term-units="contractTermUnits"
                        :id-suffix="idSuffix"
                        class="row-margin"
                    />

                    <NoticePeriod
                        v-model:noticePeriod="runtimeData.notice_period"
                        v-model:noticePeriodUnit="runtimeData.notice_period_unit"
                        :errors="errors"
                        :contract-term-units="contractTermUnits"
                        :id-suffix="idSuffix"
                    />
                </DCol>
            </DRow>
        </div>
    </DModal>
</template>

<script>
import ContractTerm from '~@/Components/Customers/Contracts/FormFields/ContractTerm.vue'
import NoticePeriod from '~@/Components/Customers/Contracts/FormFields/NoticePeriod.vue'
import PhaseStartDate from '~@/Components/Customers/Contracts/FormFields/PhaseStartDate.vue'
import _ from 'lodash'

export default {
    name: 'RuntimeModal',
    components: { PhaseStartDate, NoticePeriod, ContractTerm },
    props: {
        runtime: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        disableStartDateChange: {
            type: Boolean,
            default: false
        },
        errorsData: {
            type: Object,
            default: () => { return {} }
        },
        contractTermUnits: {
            type: Array,
            default: () => { return [] }
        },
        index: {
            type: Number,
            default: null
        }
    },
    emits: ['save-runtime', 'close-modal'],
    data () {
        return {
            errors: this.errorsData,
            runtimeData: _.cloneDeep(this.runtime)
        }
    },
    computed: {
        idSuffix () {
            return this.index === null ? '_runtime_add' : `_runtime_edit_${this.index}`
        }
    }
}
</script>

<style scoped>
.modal-content-padding {
    padding: 31px 20px !important;
}

.row-margin {
    margin-bottom: 25px !important;
}
</style>
